import { put, call, all } from 'redux-saga/effects';
import {
  SIMULATIONS_HOLDINGS_OPTIMIZATION,
  SIMULATIONS_HOLDINGS_KPIS,
  SIMULATIONS_INVESTMENT_FORECAST,
  SIMULATIONS_INVESTMENT_RECOMMENDATION,
  SIMULATIONS_EXPECTED_FEES,
} from '../actions/types';
import {
  apiSimulationHoldingsOptimization,
  apiSimulationHoldingsKpis,
  apiSimulationInvestmentObjectivesForecast,
  apiSimulationInvestmentObjectivesRecommendations,
  apiSimulationExpectedFees,
} from '../api/simulations';
import { createQadraSaga } from './shared';

function* simulationsHoldingsOptimization({
  payload: { type, objectId, varMin, varMax, targetReturn, constraints, holdings, limit },
}) {
  const { optimizationResults } = yield call(apiSimulationHoldingsOptimization, {
    varMin,
    varMax,
    targetReturn,
    constraints,
    holdings,
    limit,
  });

  yield put({
    type: SIMULATIONS_HOLDINGS_OPTIMIZATION._SUCCESS,
    payload: {
      type,
      objectId,
      constraints,
      optimizations: optimizationResults,
    },
  });
}

const watchSimulationsHoldingsOptimization = createQadraSaga(simulationsHoldingsOptimization, {
  action: SIMULATIONS_HOLDINGS_OPTIMIZATION._REQUEST,
});

function* simulationsInvestmentForecast({
  payload: {
    type,
    objectId,
    forecastAnnualMinReturn,
    forecastAnnualMeanReturn,
    forecastAnnualMaxReturn,
    timeHorizon,
    yearlyReinvestment,
    initialInvestment,
  },
}) {
  const { investmentForecast } = yield call(apiSimulationInvestmentObjectivesForecast, {
    forecastAnnualMinReturn,
    forecastAnnualMeanReturn,
    forecastAnnualMaxReturn,
    timeHorizon,
    yearlyReinvestment,
    initialInvestment,
  });

  yield put({
    type: SIMULATIONS_INVESTMENT_FORECAST._SUCCESS,
    payload: {
      type,
      objectId,
      investmentForecast,
    },
  });
}

const watchSimulationsInvestmentForecast = createQadraSaga(simulationsInvestmentForecast, {
  action: SIMULATIONS_INVESTMENT_FORECAST._REQUEST,
  take: 'latest',
});

function* simulationsInvestmentRecommendations({
  payload: {
    type,
    objectId,
    annualizedReturn,
    targetAmount,
    timeHorizon,
    initialInvestment,
    yearlyReinvestment,
  },
}) {
  const { investmentRecommendations } = yield call(
    apiSimulationInvestmentObjectivesRecommendations,
    {
      annualizedReturn,
      targetAmount,
      timeHorizon,
      initialInvestment,
      yearlyReinvestment,
    }
  );

  yield put({
    type: SIMULATIONS_INVESTMENT_RECOMMENDATION._SUCCESS,
    payload: {
      type,
      objectId,
      investmentRecommendations,
    },
  });
}

const watchSimulationsInvestmentRecommendations = createQadraSaga(
  simulationsInvestmentRecommendations,
  {
    action: SIMULATIONS_INVESTMENT_RECOMMENDATION._REQUEST,
  }
);

function* simulationsExpectedFees({
  payload: { type, objectId, startDate, endDate, initialInvestment, holdings },
}) {
  const { expectedFees } = yield call(apiSimulationExpectedFees, {
    startDate,
    endDate,
    initialInvestment,
    holdings,
  });

  yield put({
    type: SIMULATIONS_EXPECTED_FEES._SUCCESS,
    payload: {
      type,
      objectId,
      expectedFees,
    },
  });
}

const watchSimulationsExpectedFees = createQadraSaga(simulationsExpectedFees, {
  action: SIMULATIONS_EXPECTED_FEES._REQUEST,
});

function* simulationsHoldingsKpis({ payload: { items } }) {
  const entries = Object.entries(items);
  const calls = entries.map((item) => call(apiSimulationHoldingsKpis, item[1]));
  const kpisRes = yield all(calls);
  const prepareItem = entries.map((item, i) => [item[0], kpisRes[i]]);
  const kpis = Object.fromEntries(prepareItem);

  yield put({
    type: SIMULATIONS_HOLDINGS_KPIS._SUCCESS,
    payload: { kpis },
  });
}

const watchSimulationsHoldingsKpis = createQadraSaga(simulationsHoldingsKpis, {
  action: SIMULATIONS_HOLDINGS_KPIS._REQUEST,
});

export default [
  watchSimulationsHoldingsOptimization,
  watchSimulationsInvestmentForecast,
  watchSimulationsInvestmentRecommendations,
  watchSimulationsHoldingsKpis,
  watchSimulationsExpectedFees,
];
